"use strict";

var _regeneratorRuntime = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapNativeSuper = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apollo_link_ws_1 = require("@8base/apollo-link-ws");

var utils_1 = require("./utils");
/**
 * Subscription Link
 * @param {SubscriptionLinkParameters} options - The subscription link options.
 * @param {Function} options.uri - The uri which used for WebSocket connection.
 * @param {Function} [options.onAuthError] - The callback which called when attempt to refresh authentication is failed.
 * @param {Function} [options.onIdTokenExpired] - The callback which called when id token is expired.
 */


var SubscriptionLink =
/*#__PURE__*/
function (_apollo_link_ws_1$Web) {
  _inherits(SubscriptionLink, _apollo_link_ws_1$Web);

  function SubscriptionLink(_ref) {
    var _this;

    var uri = _ref.uri,
        getAuthState = _ref.getAuthState,
        onIdTokenExpired = _ref.onIdTokenExpired,
        onAuthError = _ref.onAuthError;

    _classCallCheck(this, SubscriptionLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubscriptionLink).call(this, {
      uri: uri,
      options: {
        connectionParams: function connectionParams() {
          return _this.getConnectionsParams();
        },
        connectionCallback: function connectionCallback(payload) {
          return _this.connectionCallback(payload);
        },
        reconnect: true,
        reconnectionAttempts: 5,
        lazy: true
      },
      // tslint:disable-next-line
      webSocketImpl:
      /*#__PURE__*/
      function (_WebSocket) {
        _inherits(WebSocketWithoutProtocol, _WebSocket);

        function WebSocketWithoutProtocol(url) {
          _classCallCheck(this, WebSocketWithoutProtocol);

          return _possibleConstructorReturn(this, _getPrototypeOf(WebSocketWithoutProtocol).call(this, url)); // ignore protocol
        }

        return WebSocketWithoutProtocol;
      }(_wrapNativeSuper(WebSocket))
    }));
    _this.expired = false;
    _this.getAuthState = getAuthState;
    _this.onAuthError = onAuthError;
    _this.onIdTokenExpired = onIdTokenExpired;
    return _this;
  }

  _createClass(SubscriptionLink, [{
    key: "handleTokenExpired",
    value: function handleTokenExpired() {
      if (typeof this.onIdTokenExpired === 'function') {
        return this.onIdTokenExpired();
      }

      return Promise.reject();
    }
  }, {
    key: "handleAuthFailed",
    value: function handleAuthFailed(err) {
      if (typeof this.onAuthError === 'function') {
        this.onAuthError(err);
      }
    }
  }, {
    key: "getConnectionsParams",
    value: function getConnectionsParams() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var authState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.expired) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.handleTokenExpired();

              case 3:
                this.expired = false;

              case 4:
                authState = this.getAuthState();
                return _context.abrupt("return", authState);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "connectionCallback",
    value: function connectionCallback() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (utils_1.isIdTokenExpiredError(payload)) {
        this.expired = true;
      } else if (utils_1.isRefreshTokenExpiredError(payload)) {
        this.handleAuthFailed();
      }
    }
  }]);

  return SubscriptionLink;
}(apollo_link_ws_1.WebSocketLink);

exports.SubscriptionLink = SubscriptionLink;